import React from 'react';
import './UiIcon.css';

const shapes = {
  apps: <><rect x="3" y="3" width="5" height="5" rx=".5" /><rect x="12" y="3" width="5" height="5" rx=".5" /><rect x="3" y="12" width="5" height="5" rx=".5" /><rect x="12" y="12" width="5" height="5" rx=".5" /></>,
  minimize: <path d="M4 15h12" />,
  maximize: <rect x="4" y="4" width="12" height="12" />,
  restore: <><path d="M7 4V2h11v11h-2" /><rect x="3" y="7" width="10" height="11" /></>,
  close: <path d="m5 5 10 10M15 5 5 15" />,
  plus: <path d="M10 4v12M4 10h12" />,
  external: <><path d="M11 3h6v6M17 3l-8 8" /><path d="M8 4H3v13h13v-5" /></>,
  copy: <><rect x="7" y="7" width="10" height="10" rx="1" /><path d="M13 7V3H3v10h4" /></>,
  left: <path d="M16 10H4m5-5-5 5 5 5" />,
  right: <path d="M4 10h12m-5-5 5 5-5 5" />,
  up: <path d="M10 16V4M5 9l5-5 5 5" />,
  down: <path d="M10 4v12M5 11l5 5 5-5" />,
  home: <><path d="m2 9 8-7 8 7M4 8v10h12V8" /><path d="M8 18v-6h4v6" /></>,
  search: <><circle cx="8.5" cy="8.5" r="5.5" /><path d="m13 13 4 4" /></>,
  globe: <><circle cx="10" cy="10" r="8" /><ellipse cx="10" cy="10" rx="3.5" ry="8" /><path d="M2 10h16M4 5.5h12M4 14.5h12" /></>,
  star: <path d="m10 2 2.4 5 5.6.8-4 3.9.9 5.5-4.9-2.6-4.9 2.6.9-5.5-4-3.9L7.6 7Z" />,
  cloud: <path d="M5 15a4 4 0 1 1 .6-7.9A5.5 5.5 0 0 1 16 7.5a3.8 3.8 0 0 1-.5 7.5Z" />,
  rain: <><path d="M5 11a3.5 3.5 0 1 1 .5-6.9A4.8 4.8 0 0 1 15 4.5a3.3 3.3 0 0 1 .5 6.5Z" /><path d="m6 14-1 3m5-3-1 3m5-3-1 3" /></>,
  sun: <><circle cx="10" cy="10" r="4" /><path d="M10 1v2m0 14v2M1 10h2m14 0h2M3.6 3.6 5 5m10 10 1.4 1.4M3.6 16.4 5 15m10-10 1.4-1.4" /></>,
  backspace: <><path d="M7 4h11v12H7l-5-6Z" /><path d="m10 7 5 6m0-6-5 6" /></>,
  enter: <path d="M16 4v7H4m4-4-4 4 4 4" />,
};

// Decorative, code-native controls. Never depend on an OS emoji font.
const UiIcon = ({ name, filled = false }) => <svg className={`ui-icon ui-icon--${name}`} viewBox="0 0 20 20" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{shapes[name] || shapes.apps}</svg>;
export default UiIcon;
